import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';
import { TrackingEvents } from '@/analytics/events';
import { trackCustomEvent } from '@/analytics/Mixpanel';
import { Relevance } from '@/types';

interface UseBulkUpdateFactParams {
  relevance: Relevance;
  factIds: string[];
}

export const useBulkUpdateFact = (caseId: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation(
    async ({ relevance, factIds }: UseBulkUpdateFactParams) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.PATCH,
        data: { relevance, factIds },
      });

      trackCustomEvent(TrackingEvents.BulkUpdateFact, {
        relevance,
      });

      const response = await fetch(`${APIBaseChronos}/api/case/${caseId}/fact/bulk-update`, fetchConfig);

      if (!response.ok) {
        throw new Error('Failed to update facts ');
      }

      return response;
    },
    {
      onSuccess: (_) => {
        // Invalidate relevant queries to refresh the data
        queryClient.invalidateQueries({ queryKey: [QueryEntity.CaseFacts, { caseId }] });
        queryClient.invalidateQueries({ queryKey: [QueryEntity.KeyFacts, { caseId }] });

        toast.success('Successfully updated relevance for facts');
      },
      onError: (error) => {
        console.error('Bulk update fact relevance error:', error);
        toast.error('Failed to update facts');
      },
    },
  );
};
